module.exports = __webpack_public_path__ + "img/cw_banner3.e062514f.png";